import config from "@/lib/config";
import { SendEmailCommand, SESClient } from "@aws-sdk/client-ses";

export default async function sendEmail({ address, subject, body }) {
  const ses = new SESClient({ region: "ap-northeast-1" });

  const source = `スカパー！動画ストアSPOOX <${config.email.source.vod}>`;

  const params = {
    Destination: {
      ToAddresses: [address],
    },
    Message: {
      Body: {
        Text: {
          Data: body,
          Charset: "utf-8",
        },
      },
      Subject: {
        Data: subject,
        Charset: "utf-8",
      },
    },
    Source: source,
  };
  // Return-Path、Reply-Toは設定する？
  const command = new SendEmailCommand(params);

  try {
    const result = await ses.send(command);
    return result;
  } catch (error) {
    throw error;
  }
}
